import { geohashToPolygonFeature } from "geohash-to-geojson";
import geohashpoly from 'geohash-poly';
import ngeohash from 'ngeohash';
import * as turf from '@turf/turf';

export function convertArrayToString(input) {
  let formattedString = null;

  input.map((item) => {
    formattedString =
      formattedString === null ? item : formattedString + "^" + item;
    return null;
  });
  return formattedString;
}

export function iSOnlyConsistsWithCommas(input) {
  return /^[,]*$/.test(input);
}

export function checkForLatLong(input) {
  return /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(
    input
  );
}

export const convertGeohashToPolygon = (geohash) => {
  const polygon = geohashToPolygonFeature(geohash);
  const coordinates = polygon.geometry.coordinates[0].slice(0, 4);
  return coordinates.map((x) => ({ lat: x[1], lng: x[0] }));
};

export function convertArrayToStringWithDelimeter(inputArray, delemeter) {
  let text = "";
  inputArray.map((item, index) => {
    if (index !== inputArray.length - 1) {
      text = text + item + delemeter;
    } else {
      text = text + item;
    }
    return null;
  });
  return text;
}


export function isEmpty(input) {
  if (input === null || input === "" || input === undefined) {
    return true;
  } else return false;
}

export function isNotEmpty(input) {
  return !isEmpty(input)
}

export const convertPolygonToGeohash = (polygon, precision = 5) => {
  return new Promise((resolve, reject) => {
    geohashpoly({ coords: polygon, precision }, function (err, hashes) {
      if (err) {
        console.error(err);
        resolve([]);
      } else {
        resolve(hashes);
      }
    });
  });
}

export const convertGeohashToLatLng = (geohash) => {
  const latLng = ngeohash.decode(geohash)
  return { lng: latLng.longitude, lat: latLng.latitude }
}

export const convertLatLngToGeohash = (latLng) => {
  const geohash = ngeohash.encode(latLng.lat, latLng.lng)
  return geohash
}

const getTurfPolygon = (polygonValue) => {
  const turfPolygon = turf.polygon(
    polygonValue.map((coords) => coords.map((coord) => [coord[0], coord[1]])
    )
  );
  return turfPolygon;
}

/**
 * polygonValue should be in format: [[[lon,lat], [lon,lat]]]
 * isMultiPoly: check geohash is in multiple polygons, then polygonValue = [[[[lon,lat], [lon,lat]]], [[[lon,lat], [lon,lat]]]]
 */
export const checkGeohashInPolygon = (geohashValue, polygonValue = [], isMultiPoly = false) => {
  function isInPoly(poly) {
    const turfPolygon = getTurfPolygon(poly);
    const { latitude, longitude } = ngeohash.decode(geohashValue);
    const geohashPoint = turf.point([longitude, latitude]);
    const isInside = turf.booleanPointInPolygon(geohashPoint, turfPolygon);
    return isInside;
  }

  if (isMultiPoly) {
    const isInside = polygonValue.some(x => isInPoly(x));
    return isInside;
  } else {
    const isInside = isInPoly(polygonValue);
    return isInside;
  }
}

export const generateGeohashSuggestions = (geohashValue) => {

  const base32 = "0123456789bcdefghjkmnpqrstuvwxyz"
  const subGeohashes = []
  const n = geohashValue.length

  for (let i = 0; i < base32.length; i++) {
    const subGeohash = geohashValue + base32[i]
    if (subGeohash.length === n + 1) {
      subGeohashes.push(subGeohash)
    }
  }

  return subGeohashes

}

export const isLatLngInPolygon = (lat, lng, poly) => {
  const geohashPoint = turf.point([lng, lat]);
  const turfPolygon = getTurfPolygon(poly);
  const isInside = turf.booleanPointInPolygon(geohashPoint, turfPolygon)
  return isInside;
}

export const  getQuarterByMonth = (month) => {
  const quarterMap = {
    Jan: 'Q1',
    Feb: 'Q1',
    Mar: 'Q1',
    Apr: 'Q2',
    May: 'Q2',
    Jun: 'Q2',
    Jul: 'Q3',
    Aug: 'Q3',
    Sep: 'Q3',
    Oct: 'Q4',
    Nov: 'Q4',
    Dec: 'Q4'
  };
  return quarterMap[month] || null;
}

export const getUniqueNeighbors = (geohashes = []) => {
  const uniqueNeighbors = new Set();

  geohashes.forEach(geohash => {
    const neighbors = ngeohash.neighbors(geohash);
    neighbors.forEach(neighbor => {
      if (!geohashes.includes(neighbor)) uniqueNeighbors.add(neighbor);
    });
  });

  return Array.from(uniqueNeighbors);
};

export const getArrangeMonthOrder = (currentYear, selectedMonth, dataArr) =>{
  
  const selectedYear = Number(currentYear);
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  
  const selectedMonthIndex = monthNames.findIndex(month => month.toLowerCase() === selectedMonth.toLowerCase());
  if (selectedMonthIndex === -1) {
    return []; // Invalid month
  }
  
  const currentDate = new Date(selectedYear, selectedMonthIndex);
  
  const pastSixMonths = Array.from({ length: 6 }, () => {
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    const monthName = monthNames[month];
  
    currentDate.setMonth(month - 1);
    if (month === 0) {
      currentDate.setFullYear(year - 1);
    }
  
    return { monthName, year };
  }).reverse();
  
  const arrangedData = pastSixMonths.map(({ monthName, year }) => {
    const monthData = dataArr.find(obj => obj.month === monthName);
    return monthData ? { ...monthData, monthYear: `${monthName} ${year}`, month: monthName } : null;
  }).filter(entry => entry !== null);
  
  return arrangedData
}

export const formatDecimalPoints = (value, maxDecimalPlaces) => {
  const decimalPlaces = value.toString().split('.')[1]?.length || 0;
  const roundedValue = Math.round(value * Math.pow(10, Math.min(maxDecimalPlaces, decimalPlaces))) / Math.pow(10, Math.min(maxDecimalPlaces, decimalPlaces));
  return roundedValue.toFixed(Math.min(maxDecimalPlaces, decimalPlaces));
}

export const  capitalizeFirstLetter = (string) =>{
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const sortArrayBy = (array, key, order) => {
  return array.sort((a, b) => {
      const comparison = order === 'asc' ? a[key].localeCompare(b[key]) :  b[key].localeCompare(a[key])
      return comparison
  });
};

export const calculateArrayAvg = (array, key) => {
   let sum = 0;
   array.forEach((item) => {
     sum += parseFloat(item[key]) || 0;
   });
   const average = sum / array.length;
   return parseFloat(average).toFixed(2);
} 

export const hexToRgba = (hex='', opacity=1) => {
  let c;
  if (hex?.startsWith("#")) {
    c = hex.substring(1);
  } else {
    c = hex;
  }
  const bigint = parseInt(c.length === 3 ? c + c : c, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const maskString = (str, maxLength) => str?.length > maxLength ? str?.slice(0, maxLength) + '...' : str;

// Function to check for polygon intersections
export const  checkIntersections = async (userPolygon, radius, definedPolygons) => {
  let userGeometry;

  // Determine the geometry type based on the userPolygon input
  if (Array.isArray(userPolygon)) {
      const coordsArray = userPolygon?.map((item) => {
          return item.map((loc) => {
              return [loc.lng, loc.lat];
          });
      });

      if (userPolygon.length > 1) {
          // MultiPolygon
          const multiPolygonCoords = coordsArray?.map((polygon) => {
              if (
                  polygon[0][0] !== polygon[polygon.length - 1][0] ||
                  polygon[0][1] !== polygon[polygon.length - 1][1]
              ) {
                  polygon.push(polygon[0]); // Ensure ring closure
              }
              return [polygon];
          });

          userGeometry = {
              type: "MultiPolygon",
              coordinates: multiPolygonCoords,
          };
      } else if (userPolygon[0].length > 2) {
          // Polygon
          if (
              coordsArray[0][0][0] !==
                  coordsArray[0][coordsArray[0].length - 1][0] ||
              coordsArray[0][0][1] !== coordsArray[0][coordsArray[0].length - 1][1]
          ) {
              coordsArray[0].push(coordsArray[0][0]);
          }

          userGeometry = {
              type: "Polygon",
              coordinates: coordsArray,
          };
      } else if (userPolygon[0].length) {
          userGeometry = turf.circle(
              coordsArray[0][0],
              radius,
              { steps: 64 }
          );
      }
  } else {
      throw new Error("Invalid user selection");
  }

  const result = [];

  definedPolygons?.forEach((defined) => {
      const polyCoords = defined.poly.map((point) => [point.lng, point.lat]);
      const definedPoly = {
          type: "Polygon",
          coordinates: [polyCoords],
      };

      try {
          if (userGeometry.type === "MultiPolygon") {
              // Handle MultiPolygon by iterating through each Polygon
              userGeometry.coordinates.forEach((polygonCoords) => {
                  const singlePolygon = {
                      type: "Polygon",
                      coordinates: polygonCoords,
                  };

                  const intersection = turf.intersect(singlePolygon, definedPoly);

                  if (intersection) {
                      if (turf.booleanContains(singlePolygon, definedPoly)) {
                          if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                              result.push(defined.ms);
                          }
                      } else if (turf.booleanContains(definedPoly, singlePolygon)) {
                          if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                              result.push(defined.ms);
                          }
                      } else {
                          if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                              result.push(defined.ms);
                          }
                      }
                  }
              });
          } else {
              const intersection = turf.intersect(userGeometry, definedPoly);

              if (intersection) {
                  if (turf.booleanContains(userGeometry, definedPoly)) {
                      if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                          result.push(defined.ms);
                      }
                  } else if (turf.booleanContains(definedPoly, userGeometry)) {
                      if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                          result.push(defined.ms);
                      }
                  } else {
                      if (!result.some((item) => JSON.stringify(item) === JSON.stringify(defined.ms))) {
                          result.push(defined.ms);
                      }
                  }
              }
          }
      } catch (error) {
        throw new Error("Error while processing the polygon intersections.");
      }
  });

  return result;
};